import { computed, ref, onBeforeMount, reactive } from 'vue';
import dayjs from '@/utils/dayjs';
import { useAuthStore } from '@/stores/auth';

export type popupFlag = 'show' | 'noShow';

const popupCondition = () => {
  // 공지 카테고리 : CJ택배사지연 , 2022설, 2022추석, 시스템 점검, 0501 근로자의날 휴무, 배송지연안내

  const isOpenPopup = dayjs().isBetween('2026-04-30 18:00', '2026-05-09 09:00');
  if (isOpenPopup)
    return {
      title: '특수일 할증 적용 안내',
      src: '2026-04-30.png',
      category: '특수일할증',
    };
  else
    return {
      title: '',
      src: '',
      category: '',
    };
};

/**
 * 유인팝업
 */
export function useMannedPopup(item: 'parcel' | 'quick') {
  const renderItem: 'all' | 'parcel' | 'quick' = 'quick';
  const mannedData = reactive<{ title: string; src: string; category: string }>({
    ...popupCondition(),
  });

  const isMannedPopup = ref<boolean>(true);
  const mannedPopup = computed({
    get: () => {
      return localStorage.getItem(mannedData.category) as popupFlag;
    },
    set: (value: popupFlag) => {
      localStorage.setItem(mannedData.category, value);
    },
  });

  const closeMannedPopup = () => {
    isMannedPopup.value = false;
  };
  const closeMannedPopupNoMore = () => {
    closeMannedPopup();
    mannedPopup.value = 'noShow';
  };

  onBeforeMount(() => {
    if (!mannedData.src) return (isMannedPopup.value = false); // 공지할 이미지가 없으면 띄우지 않습니다.
    // if (item !== renderItem) return;

    // 유인지점이 아닌 경우 팝업 x
    // if (store.state.auth.centerInfo.staff === false) return;

    if (mannedPopup.value === 'show') isMannedPopup.value = true;
    else if (mannedPopup.value === 'noShow') isMannedPopup.value = false;
    else {
      isMannedPopup.value = true;
      localStorage.setItem(mannedData.category, 'show');
    }
  });

  return {
    mannedData,
    isMannedPopup,
    closeMannedPopup,
    closeMannedPopupNoMore,
  };
}

/**
 *
 * @returns 특정일자&특정지점 체크 통과시 ? popup path : ""
 */
const noticePopupCondition = () => {
  const center = computed(() => useAuthStore().centerInfo);
  const gotchaOpenCenter =
    import.meta.env.VITE_ENV === 'master' ? '62d501d545b113001cb20ed2' : '62a1729a6352c9001c985238';

  const allowTime = dayjs().isBetween('2024-11-11 00:00', '2024-11-30 23:59');
  const allowCenter = center.value.centerId === gotchaOpenCenter;

  return allowTime && allowCenter ? 'notice_popup_gotcha.png' : '';
};

/**
 * 팝업 특수지점 노출 여부
 */
export function useNoticePopup() {
  // 공지 카테고리 : 2024설 택배사변경CJTO한진, 2022설, 이노텍 파주 세차오픈, 세차 서비스 종료 안내
  const category = '세차 서비스 종료 안내';
  const noticeData = reactive<{ title: string; src: string }>({
    title: '세차 서비스 종료 안내',
    src: noticePopupCondition(),
  });
  const isNoticePopup = ref<boolean>(true);
  const noticePopup = computed({
    get: () => {
      return localStorage.getItem(category) as popupFlag;
    },
    set: (value: popupFlag) => {
      localStorage.setItem(category, value);
    },
  });

  const closePopup = () => {
    isNoticePopup.value = false;
  };
  const closePopupNoMore = () => {
    closePopup();
    noticePopup.value = 'noShow';
  };

  onBeforeMount(() => {
    if (!noticeData.src) return (isNoticePopup.value = false);

    if (noticePopup.value === 'show') isNoticePopup.value = true;
    else if (noticePopup.value === 'noShow') isNoticePopup.value = false;
    else {
      isNoticePopup.value = true;
      localStorage.setItem(category, 'show');
    }
  });

  return {
    closePopup,
    closePopupNoMore,
    isNoticePopup,
    noticePopup,
    noticeData,
  };
}
